import React, {useState, useEffect} from 'react';
import { useCookies } from "react-cookie";
import configVars from "../../config";
import { useTranslation } from "react-i18next";

const UserMembership = (props) => {

    const [cookies] = useCookies(["sustainyou_user_jwt"]);
    const [showPauseOptions, setShowPauseOptions] = useState(false);
    const [showResumeOptions, setShowResumeOptions] = useState(false);
    const [showCancelOptions, setShowCancelOptions] = useState(false);
    const [showReactivate, setShowReactivate] = useState(false);
    const [pausePeriod, setPausePeriod] = useState(0);
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState('');
    const [nextInvoiceDate, setNextInvoiceDate] = useState('');
    const [statusColor, setStatusColor] = useState('');

    const [translation] = useTranslation("translations");

    useEffect(() => {

        if ( props?.memberships?.pause && props?.memberships?.pause.behavior ) {
            setStatus('paused');
            setNextInvoiceDate( props?.memberships?.pause.resumes_at );
            setStatusColor('sy-yellow');
        } else {

            setStatus( props?.memberships?.status );
            setNextInvoiceDate( props?.memberships?.renew_date );
            
            if ( props?.memberships?.status === 'active' ) {
                setStatusColor('sy-green');
            } else {
                setStatusColor('sy-red');
            }
            
        }

        if ( props?.memberships?.cancel_at_period_end === true ) {
            setStatus('canceled');
            setNextInvoiceDate( props?.memberships?.canceled_at );
            setStatusColor('sy-red');
        }



    }, [props]);

    const formatDate = (timestamp) => {

        if ( ! timestamp ) return;

        const dataObject = new Date((timestamp*1000));
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const formattedDate = dataObject.toLocaleDateString('sv-SE', options);

        return formattedDate;

    }

    const handlePause = async (id, period, renewDate) => {
        
        if ( !id || !period || !renewDate ) return;

        if ( ! cookies.sustainyou_user_jwt )  return;

        setLoading(true);

        let userRequestData = new FormData();
            userRequestData.append( 'token', cookies.sustainyou_user_jwt );
            userRequestData.append( 'sub_id', id );
            userRequestData.append( 'period', period );
            userRequestData.append( 'renew_date', renewDate );

            const fetchUrl = `${configVars.apiUrl}sustainchange/v1/pausestripesubscription/`;

            try{

                const response = await fetch(
                    fetchUrl,
                    {
                    method: "POST",
                    headers: {
                        Authorization: `Basic ${configVars.auth}`,
                    },
                    body: userRequestData
                    }
                );
                
                const updateResponse = await response.json();
        
                if ( updateResponse ) {

                    if ( updateResponse.success === true ) {

                        const subscriptionData = updateResponse?.data.updated_subscription;

                        if ( subscriptionData?.pause_collection && subscriptionData?.pause_collection?.behavior ) {
                            setStatus('paused');
                            setNextInvoiceDate( subscriptionData?.pause_collection?.resumes_at );
                            setStatusColor('sy-yellow');
                        } else {
                
                            setStatus( subscriptionData?.status );
                            setNextInvoiceDate( subscriptionData?.current_period_end );
                            
                            if ( subscriptionData?.status === 'active' ) {
                                setStatusColor('sy-green');
                            } else {
                                setStatusColor('sy-red');
                            }
                            
                        }

                        setShowPauseOptions(false);
                    }
                    

                    //console.log( updateResponse );

                }

            } catch( error ) {
                console.log( error );
                return error;
            }

            setLoading( false );

    }

    const resumeSubscription = async (id) => {
        
        if (!id) return;
        if ( ! cookies.sustainyou_user_jwt )  return;

        setLoading(true);

        let userRequestData = new FormData();
            userRequestData.append( 'token', cookies.sustainyou_user_jwt );
            userRequestData.append( 'sub_id', id );

            const fetchUrl = `${configVars.apiUrl}sustainchange/v1/resumestripesubscription/`;

            try{

                const response = await fetch(
                    fetchUrl,
                    {
                    method: "POST",
                    headers: {
                        Authorization: `Basic ${configVars.auth}`,
                    },
                    body: userRequestData
                    }
                );
                
                const updateResponse = await response.json();
        
                if ( updateResponse ) {

                    if ( updateResponse.success === true ) {

                        const subscriptionData = updateResponse?.data.updated_subscription;

                        if ( subscriptionData?.pause_collection && subscriptionData?.pause_collection?.behavior ) {
                            setStatus('paused');
                            setNextInvoiceDate( subscriptionData?.pause_collection?.resumes_at );
                            setStatusColor('sy-yellow');
                        } else {
                
                            setStatus( subscriptionData?.status );
                            setNextInvoiceDate( subscriptionData?.current_period_end );
                            
                            if ( subscriptionData?.status === 'active' ) {
                                setStatusColor('sy-green');
                            } else {
                                setStatusColor('sy-red');
                            }
                            
                        }

                        setShowResumeOptions(false);
                    }

                    //console.log( updateResponse );

                }

            } catch( error ) {
                console.log( error );
                return error;
            }

            setLoading( false );

    }

    const cancelSubscription = async (id, type) => {

        if ( !id || !type ) return;

        if ( ! cookies.sustainyou_user_jwt )  return;

        setLoading(true);

        let userRequestData = new FormData();
            userRequestData.append( 'token', cookies.sustainyou_user_jwt );
            userRequestData.append( 'sub_id', id );
            userRequestData.append( 'type', type );

            const fetchUrl = `${configVars.apiUrl}sustainchange/v1/handlestripesubscriptioncancel/`;

            try{

                const response = await fetch(
                    fetchUrl,
                    {
                    method: "POST",
                    headers: {
                        Authorization: `Basic ${configVars.auth}`,
                    },
                    body: userRequestData
                    }
                );
                
                const updateResponse = await response.json();
        
                if ( updateResponse ) {

                    if ( updateResponse.success === true ) {

                        const subscriptionData = updateResponse?.data.updated_subscription;

                        if ( subscriptionData?.cancel_at_period_end === true ) {
                            setStatus('canceled');
                            setNextInvoiceDate( subscriptionData?.canceled_at );
                            setStatusColor('sy-red');
                        } else {
                
                            setStatus( subscriptionData?.status );
                            setNextInvoiceDate( subscriptionData?.current_period_end );
                            
                            if ( subscriptionData?.status === 'active' ) {
                                setStatusColor('sy-green');
                            } else {
                                setStatusColor('sy-yellow');
                            }
                            
                        }


                    }

                    //console.log( updateResponse );

                    setShowCancelOptions(false);
                    setShowReactivate(false);

                }

            } catch( error ) {
                console.log( error );
                return error;
            }

            setLoading( false );

    }

    return(

        <div className="membership-wrap">
            <div className="mx-auto" style={{maxWidth: '800px'}}>
                <div className="row">
                    <div className="col-12 col-lg-4 d-flex flex-column">
                        <span className="fw-bold">{translation("membership_details")}</span>
                        <span className="opacity-half font-size-medium d-inline-block w-100 position-relative" style={{top: '-3px'}}>{translation("manage_membership")}</span>
                    </div>
                    <div className="col-12 col-lg-8">

                        { props?.loading &&
                            <div className="d-flex mb-4">
                                <div className="spinner-border" role="status" >
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        }

                        { props?.memberships && !props?.loading && props?.source === 'stripe' &&
                            <>
                                <div className="d-flex card-item-wrap align-items-center shadow-sm rounded px-3 py-2 my-2 bg-dark-grey cursor-pointer position-relative">
                                    <div className="pe-3">
                                        <i className="fa fa-user fa-lg" aria-hidden="true"></i>
                                    </div>

                                    { props?.source === 'stripe' &&
                                        <div>
                                            <div className="d-flex align-items-center">
                                                <span className="me-2">{props?.memberships?.name} Prenumeration </span>
                                                <span className={`text-capitalize badge rounded-pill bg-${statusColor}`}>{status}</span>
                                            </div>
                                            { status === 'active' &&
                                                <span className="opacity-half font-size-medium position-relative" style={{top: '-5px'}}>{translation("next_invoice")} <span className="text-capitalize">{ formatDate(nextInvoiceDate) }</span></span>
                                            }

                                            { status === 'paused' &&
                                                <span className="opacity-half font-size-medium position-relative d-inline-block w-100" style={{top: '-5px'}}>{translation("resume_on")} <span className="text-capitalize fw-bold">{ formatDate(nextInvoiceDate) }.</span></span>
                                            }

                                            { status === 'canceled' &&
                                                <span className="opacity-half font-size-medium position-relative" style={{top: '-5px'}}>{translation("canceled_at")} <span className="text-capitalize">{ formatDate(nextInvoiceDate) }</span></span>
                                            }

                                            { (status === 'paused' || status === 'canceled') && props?.memberships?.status === 'active' &&
                                                <span className="opacity-half font-size-medium position-relative d-inline-block w-100s" style={{top: '-5px'}}>{translation("use_until")} <span className="text-capitalize fw-bold">{ formatDate(props?.memberships?.renew_date) }.</span></span>
                                            }

                        
                                            
                                        </div>
                                    }
                                </div>

                                <div className="mt-4">

                                    <div className="toast-container">
                                        <div className={`toast fade ${showPauseOptions ? 'show' : ''}`} role="alert" aria-live="assertive" aria-atomic="true">
                                            <div className="toast-header">
                                                <strong className="me-auto">{translation("pause_options")}</strong>
                                                <button type="button" className="btn-close" aria-label="Close" onClick={() => setShowPauseOptions(false)}></button>
                                            </div>
                                            <div className="toast-body">
                                                {translation("pause_options_msg")}
                                                <div className="mt-2 pt-2">
                                                    <button type="button" className="btn btn-primary btn-sm text-white me-2" onClick={() => setPausePeriod(30)}>
                                                        <span>30 {translation("days_text")}</span>
                                                        { pausePeriod === 30 &&
                                                            <span className="ms-2"><i className="fa fa-check" aria-hidden="true"></i></span>
                                                        }
                                                        
                                                    </button>
                                                    <button type="button" className="btn btn-primary btn-sm text-white" onClick={() => setPausePeriod(60)}>
                                                        <span>60 {translation("days_text")}</span>
                                                        { pausePeriod === 60 &&
                                                            <span className="ms-2"><i className="fa fa-check" aria-hidden="true"></i></span>
                                                        }
                                                    </button>
                                                    
                                                    { (pausePeriod === 30 || pausePeriod === 60) && 
                                                        <button type="button" className="btn btn-secondary btn-sm text-white ms-2 float-end" onClick={ () => handlePause(props?.memberships?.id, pausePeriod, props?.memberships?.renew_date)}>
                                                            <span className="me-2">{translation("pause_text")}</span>
                                                            {loading &&
                                                                <div className="spinner-border spinner-border-sm text-light" role="status">
                                                                    <span className="visually-hidden">Loading...</span>
                                                                </div>
                                                            }
                                                            
                                                            {!loading &&
                                                                <i className="fa fa-hand-o-right" aria-hidden="true"></i>
                                                            }
                                                        </button>
                                                    }
                                                    
                                                </div>
                                            </div>
                                        </div>

                                        <div className={`toast fade ${showResumeOptions ? 'show' : ''}`} role="alert" aria-live="assertive" aria-atomic="true">
                                            <div className="toast-header">
                                                <strong className="me-auto">{translation("resume_warning")}</strong>
                                                <button type="button" className="btn-close" aria-label="Close" onClick={() => setShowResumeOptions(false)}></button>
                                            </div>
                                            <div className="toast-body">
                                                {translation("resume_warning_des")} {formatDate(props?.memberships?.renew_date)}.
                                                <div className="mt-2 pt-2 d-flex justify-content-end">
    
                                                    <button type="button" className="btn btn-secondary btn-sm text-white" onClick={() => resumeSubscription(props?.memberships?.id)}>
                                                        <span className="me-2">{translation("proceed_text")}</span>
                                                        {loading &&
                                                            <div className="spinner-border spinner-border-sm text-light" role="status">
                                                                <span className="visually-hidden">Loading...</span>
                                                            </div>
                                                        }
                                                        {!loading &&
                                                            <span><i className="fa fa-hand-o-right" aria-hidden="true"></i></span>
                                                        }
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className={`toast fade ${showCancelOptions ? 'show' : ''}`} role="alert" aria-live="assertive" aria-atomic="true">
                                            <div className="toast-header">
                                                <strong className="me-auto">{translation("cancel_warning")}</strong>
                                                <button type="button" className="btn-close" aria-label="Close" onClick={() => setShowCancelOptions(false)}></button>
                                            </div>
                                            <div className="toast-body">
                                                {translation("cancel_warning_1")} <span className="text-capitalize fw-bold">{formatDate(props?.memberships?.renew_date)}</span>.<br/><br/> {translation("cancel_warning_2")} <span className="text-capitalize fw-bold">{formatDate(props?.memberships?.renew_date)}</span>.
                                                <div className="mt-2 pt-2 d-flex justify-content-end">
    
                                                    <button type="button" className="btn btn-secondary btn-sm text-white" onClick={() => cancelSubscription(props?.memberships?.id, 'cancel')}>
                                                        <span className="me-2">{translation("proceed_text")}</span>
                                                        {loading &&
                                                            <div className="spinner-border spinner-border-sm text-light" role="status">
                                                                <span className="visually-hidden">Loading...</span>
                                                            </div>
                                                        }
                                                        {!loading &&
                                                            <span><i className="fa fa-hand-o-right" aria-hidden="true"></i></span>
                                                        }
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className={`toast fade ${showReactivate ? 'show' : ''}`} role="alert" aria-live="assertive" aria-atomic="true">
                                            <div className="toast-header">
                                                <strong className="me-auto">{translation("reactivate_warning")}</strong>
                                                <button type="button" className="btn-close" aria-label="Close" onClick={() => setShowReactivate(false)}></button>
                                            </div>
                                            <div className="toast-body">
                                                {translation("reactivate_warning_msg")} {formatDate(props?.memberships?.renew_date)}.
                                                <div className="mt-2 pt-2 d-flex justify-content-end">
    
                                                    <button type="button" className="btn btn-secondary btn-sm text-white" onClick={() => cancelSubscription(props?.memberships?.id, 'activate')}>
                                                        <span className="me-2">{translation("proceed_text")}</span>
                                                        {loading &&
                                                            <div className="spinner-border spinner-border-sm text-light" role="status">
                                                                <span className="visually-hidden">Loading...</span>
                                                            </div>
                                                        }
                                                        {!loading &&
                                                            <span><i className="fa fa-hand-o-right" aria-hidden="true"></i></span>
                                                        }
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    { !showPauseOptions && !showCancelOptions && status === 'active' &&
                                        <div>
                                            <button type="button" className="btn p-0 text-secondary" onClick={() => setShowPauseOptions(true)}>
                                                <i className="fa fa-pause" aria-hidden="true"></i>
                                                <span className="ps-2">{translation("pause_text")} {translation("membership_txt")}</span>
                                            </button>
                                        </div>
                                    }

                                    { !showResumeOptions && status === 'paused' &&
                                        <div>
                                            <button type="button" className="btn p-0 text-secondary" onClick={() => setShowResumeOptions(true)}>
                                                <i className="fa fa-play" aria-hidden="true"></i>
                                                <span className="ps-2">{translation("resume_text")} {translation("membership_txt")}</span>
                                            </button>
                                        </div>
                                    }

                                    { !showPauseOptions && !showResumeOptions && !showCancelOptions && status !== 'canceled' &&
                                        <div className="mt-3">
                                            <button type="button" className="btn p-0 text-secondary" onClick={() => setShowCancelOptions(true)}>
                                                <i className="fa fa-ban" aria-hidden="true"></i>
                                                <span className="ps-2">{translation("cancel_text")} {translation("membership_txt")}</span>
                                            </button>
                                        </div>
                                    }

                                    { !showReactivate && status === 'canceled' &&  props?.memberships?.status === 'active' &&
                                        <div className="mt-3">
                                            <button type="button" className="btn p-0 text-secondary" onClick={() => setShowReactivate(true)}>
                                                <i className="fa fa-play" aria-hidden="true"></i>
                                                <span className="ps-2">{translation("reactivate_text")} {translation("membership_txt")}</span>
                                            </button>
                                        </div>
                                    }

                                </div>
                            </>
                        }

                        { props?.source === 'wp' &&
                            <>
                                <div className="my-3 w-100">
                                    <div className="alert alert-secondary" role="alert">
                                    {translation("no_membership_op_1")} <a href="mailto:contact@sustainchange.se">contact@sustainchange.se</a> {translation("no_membership_op_2")}
                                    </div>
                                </div>

                                { props?.memberships && Array.isArray( props?.memberships ) && props?.memberships?.length > 0 &&
                                    <div className="memberships-wrap mt-2">

                                        { props?.memberships?.map((membership, index) => {

                                            return (
                                                <div className="d-flex card-item-wrap align-items-center shadow-sm rounded px-3 py-2 my-2 bg-dark-grey cursor-pointer position-relative" key={index}>
                                                    <div className="pe-3">
                                                        <i className="fa fa-user fa-lg" aria-hidden="true"></i>
                                                    </div>

                                                    <div>
                                                        <div className="d-flex align-items-center">
                                                            <span className="me-2">{membership?.name} </span>
                                                        </div>
                                                        { membership?.start_date &&
                                                            <span className="opacity-half font-size-medium position-relative" style={{top: '-5px'}}>{translation("started_on")}: <span className="text-capitalize">{ membership?.start_date }</span></span>
                                                        }
                                                        { membership?.end_date &&
                                                            <span className="opacity-half font-size-medium position-relative" style={{top: '-5px'}}>{translation("expiring_on")}: <span className="text-capitalize">{ membership?.end_date }</span></span>
                                                        }
                                                        

                                    
                                                        
                                                    </div>
                                                </div>
                                            )

                                        })}

                                    </div>
                                    
                                }

                            </>
                        }


                    </div>
                </div>
            </div>
        </div>

    )
}

export default UserMembership;